/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect } from "react";
import {
  I2cInput,
  I2cRadio,
  I2cRadioGroup,
  I2cPhoneField,
  I2cListItem,
  I2cTooltip,
  I2cIcon,
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../Prepaid.scss";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { corporateFundingSource }  from "./stringUtils";
import { validationSchemaFraudManagement }  from "./validationScheme";

const FraudManagement = ({
  setAddFormData,
  addFormData,
  setFormValidStates,
  formDataJson,
  isFetching,
}) => {  
  // Initialize React Hook Form with Yup resolver
  const methods = useForm({
    resolver: yupResolver(validationSchemaFraudManagement),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "firstError",
    defaultValues: {
      of_fm_service_type: "",
      of_fm_company_name: "",
      of_fm_contact_name: "",
      of_fm_job_title: "",
      of_fm_phone_number: "",
      of_fm_country: "",
      of_fm_email: "",
    },
  });

  // Controlls destructuring from the method
  const {
    control,
    formState: { errors },
  } = methods;

  const fields = [
    "of_fm_service_type",
    "of_fm_company_name",
    "of_fm_contact_name",
    "of_fm_job_title",
    "of_fm_phone_number",
    "of_fm_country",
    "of_fm_email",
  ];
  useEffect(() => {
    if (!isFetching && Object.keys(formDataJson ?? {}).length) {
      fields.forEach((field) => {
        methods.setValue(field, formDataJson[4]["4_0"][field] ?? "");
      });
      methods.trigger();
    }
  }, [isFetching]);

  // Trigger validation when component mounts
  React.useEffect(() => {
    methods.trigger();
  }, []);
  const handleValueChanges = () => {
    const values = methods.getValues();
    setAddFormData({
      ...addFormData,
      4: {
        ...addFormData["4"],
        "4_0": { ...values },
      },
    });
  };

  // Update form validation state when errors change
  React.useEffect(() => {
    const errorsLength = Object.keys(errors).length;
    if (errorsLength === 0) setFormValidStates("4_0", true);
    else setFormValidStates("4_0", false);
    handleValueChanges();
  }, [Object.keys(errors).length]);

  return (
    <React.Fragment>
      <div className="forms-instance">
        <div i2c-grid="grid gap-sm">
          <div i2c-grid="12">
            <div className="single-field-wrapper">
              <Controller
                name="of_fm_service_type"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    value={methods.watch("of_fm_service_type")}
                    {...field}
                    name="of_fm_service_type"
                    onI2cChange={(e) => {
                      [
                        "of_fm_company_name",
                        "of_fm_contact_name",
                        "of_fm_job_title",
                        "of_fm_phone_number",
                        "of_fm_country",
                        "of_fm_email",
                      ].map((field) => methods.setValue(field, ""));
                      field.onChange(e);
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    <div i2c-grid="grid gap-sm">
                      {corporateFundingSource.map((radio, index) => (
                        <I2cListItem
                          key={index}
                          i2c-grid="4@md"
                          className="cardlist-custom-direction"
                          variant="receipt"
                          label={radio.label}
                          sublabel=""
                          checked={
                            methods.watch("of_fm_service_type") ===
                            radio.value.toLowerCase()
                          }
                          type="checkbox"
                        >
                          <I2cRadio
                            slot="prefix"
                            filled
                            value={radio.value}
                            checked={
                              methods.watch("of_fm_service_type") ===
                              radio.value
                            }
                          ></I2cRadio>
                          {radio.text && (
                            <I2cTooltip
                              slot="suffix"
                              hoist
                              content={radio.text}
                              placement="right-start"
                            >
                              <I2cIcon
                                color="#A1A3AE"
                                name="cs-linear-help-circle"
                              ></I2cIcon>
                            </I2cTooltip>
                          )}
                        </I2cListItem>
                      ))}
                    </div>
                  </I2cRadioGroup>
                )}
              />
            </div>
          </div>
          {methods.watch("of_fm_service_type") === "other" && (
            <div i2c-grid="12">
              <div className="custom-label-light mb-12">
                If using a 3rd Party Vendor, please provide details
              </div>
              <div i2c-grid="grid gap-column-sm gap-row-md">
                <div i2c-grid="6@md 4@lg">
                  <div className="single-field-wrapper">
                    <Controller
                      name="of_fm_company_name"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          className="single-input-field"
                          onI2cInput={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            handleValueChanges();
                          }}
                          size="large"
                          label="Company Name" 
                          placeholder="Enter Company Name"
                          name={"of_fm_company_name"}
                        />
                      )}
                    />
                    {/* <ErrorMessage
                      show={
                        errors.of_fm_company_name &&
                        methods.formState.touchedFields.of_fm_company_name
                          ? true
                          : false
                      }
                      message={
                        errors.of_fm_company_name?.message ?? "Invalid input"
                      }
                    /> */}
                  </div>
                </div>
                <div i2c-grid="6@md 4@lg">
                  <div className="single-field-wrapper">
                    <Controller
                      name="of_fm_contact_name"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          className="single-input-field"
                          onI2cInput={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            handleValueChanges();
                          }}
                          size="large" 
                          label="Contact Name"
                          placeholder="Enter Contact Name"
                          name={"of_fm_contact_name"}
                        />
                      )}
                    />
                    {/* <ErrorMessage
                      show={
                        errors.of_fm_contact_name &&
                        methods.formState.touchedFields.of_fm_contact_name
                          ? true
                          : false
                      }
                      message={
                        errors.of_fm_contact_name?.message ?? "Invalid input"
                      }
                    /> */}
                  </div>
                </div>
                <div i2c-grid="6@md 4@lg">
                  <div className="single-field-wrapper">
                    <Controller
                      name="of_fm_job_title"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          className="single-input-field"
                          onI2cInput={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            handleValueChanges();
                          }}
                          size="large"  
                          label="Title"
                          placeholder="Enter Title"
                          name={"of_fm_job_title"}
                        />
                      )}
                    />
                    {/* <ErrorMessage
                      show={
                        errors.of_fm_job_title &&
                        methods.formState.touchedFields.of_fm_job_title
                          ? true
                          : false
                      }
                      message={
                        errors.of_fm_job_title?.message ?? "Invalid input"
                      }
                    /> */}
                  </div>
                </div>
                <div i2c-grid="6@md 4@lg">
                  <div className="single-field-wrapper">
                    <I2cPhoneField
                      format="NATIONAL"
                      label="Company Phone "
                      tooltip-help="Custom Text"
                      name="ci_companyName"
                      size="large"
                      country-box
                      show-flags
                      selectedCountry={methods.watch("of_fm_country") || "US"}
                      value={methods.watch("of_fm_phone_number")}
                      errorMessageVisible={false} 
                      onI2cChange={(e) => {
                        const country = e.target.country;
                        const isValid = e.target.isValid;
                        const value = e.target.value;
                        methods.setValue("of_fm_country", country);
                        methods.setValue("of_fm_phone_number", value);
                        handleValueChanges();
                        if (!isValid) {
                          methods.setError("of_fm_phone_number", {
                            message: e.target.guide,
                          });
                        } else {
                          methods.clearErrors("of_fm_phone_number");
                        }
                      }}
                    />
                    {/* <ErrorMessage
												show={
													errors.of_fm_phone_number &&
													methods.formState.touchedFields.of_fm_phone_number
														? true
														: false
												}
												message={
													errors.of_fm_phone_number?.message ?? "Invalid input"
												}
											/> */}
                  </div>
                </div>
                <div i2c-grid="6@md 4@lg">
                  <div className="single-field-wrapper">
                    <Controller
                      name="of_fm_email"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          className="single-input-field"
                          onI2cInput={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            handleValueChanges();
                          }}
                          size="large"
                          label="Email" 
                          type="email"
                          placeholder="Enter Email"
                          name={"of_fm_email"}
                        />
                      )}
                    />
                    {/* <ErrorMessage
                      show={
                        errors.of_fm_email &&
                        methods.formState.touchedFields.of_fm_email
                          ? true
                          : false
                      }
                      message={errors.of_fm_email?.message ?? "Invalid input"}
                    /> */}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default FraudManagement;
